//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ElementIntBuilder.js";
let d=[[[0,"EnumValue",1,0]],[],[]];
SPLM.CAM.OutputAxis = class extends SPLM.CAM.ElementIntBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.OutputAxis";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.OutputAxis.Types = Object.freeze({
    "Automatic" : "Automatic", "NormalToLevel" : "NormalToLevel", "AwayFromAxisOfRotation" : "AwayFromAxisOfRotation", "InterpolateTilt" : "InterpolateTilt", "AlignTiltFromPoint" : "AlignTiltFromPoint", "TowardPoint" : "TowardPoint", "FixedVector" : "FixedVector", "NormalToDrive" : "NormalToDrive", "TowardLine" : "TowardLine", "TowardFiniteLine" : "TowardFiniteLine", "FourAxisNormalToDrive" : "FourAxisNormalToDrive", "AwayFromFixedPoint" : "AwayFromFixedPoint", "AwayFromLine" : "AwayFromLine", "AwayFromFiniteLine" : "AwayFromFiniteLine", "TangentToCurve" : "TangentToCurve", "AlignTiltFromCurve" : "AlignTiltFromCurve", "TowardCurve" : "TowardCurve", "AwayFromCurve" : "AwayFromCurve", "RelativeToDrive" : "RelativeToDrive", "ParametricInterp" : "ParametricInterp", "InterpolateBetween" : "InterpolateBetween", "SameAsInfill" : "SameAsInfill", "SameAsFinishPass" : "SameAsFinishPass"});

export default SPLM;